import React from 'react';
import t from 'prop-types';

var BotonLibro = function BotonLibro(_ref) {
  var libroId = _ref.libroId,
      seleccionado = _ref.seleccionado,
      onIndice = _ref.onIndice;
  return React.createElement('div', {
    className: 'botonLibro ' + libroId + (seleccionado ? ' activa' : ''),
    onClick: function onClick() {
      return onIndice(libroId);
    }
  });
};

BotonLibro.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string.isRequired,
  seleccionado: t.bool.isRequired,
  onIndice: t.func.isRequired
} : {};
export default BotonLibro;